// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IvTaDomcHbBGNJj46vXh {
    overflow: hidden;
    background: white;
}

.idgVeYY_ERApvkSyuwna {
    padding-bottom: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1 !important;
}

.Fb5pmGmajjuChrmxN82T {
    text-align: center;
    font-weight: 600;
    color: #666;
    border-right: 1px solid #e0e0e0;
}

.Fb5pmGmajjuChrmxN82T:last-child {
    border-right: none;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Shared/AvailabilityShared/CalendarContent/CalendarContent.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".calendar {\n    overflow: hidden;\n    background: white;\n}\n\n.dayHeaderContainer {\n    padding-bottom: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-grow: 1 !important;\n}\n\n.dayHeader {\n    text-align: center;\n    font-weight: 600;\n    color: #666;\n    border-right: 1px solid #e0e0e0;\n}\n\n.dayHeader:last-child {\n    border-right: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendar": `IvTaDomcHbBGNJj46vXh`,
	"dayHeaderContainer": `idgVeYY_ERApvkSyuwna`,
	"dayHeader": `Fb5pmGmajjuChrmxN82T`
};
export default ___CSS_LOADER_EXPORT___;
